"use client";
import { ReactNode, useState } from "react";
import { cva, VariantProps } from "class-variance-authority";
import { cn } from "../../utils/cn";
import {
  CircleAlertIcon,
  CircleCheckIcon,
  CircleXIcon,
  InfoIcon,
  XIcon,
} from "lucide-react";
import { IconButton } from "../Buttons";

export type StyleVariant = "info" | "warning" | "error" | "success";
const styles = cva(
  [
    "rounded-lg py-4 text-base px-3 pr-11 flex items-stretch gap-2  font-normal relative",
    "bg-gray-100",
  ],
  {
    variants: {
      vType: {
        info: "text-blue-600 ",
        success: "text-green-600 ",
        error: "text-red-600 ",
        warning: "text-yellow-600 ",
      },
    },
    defaultVariants: {
      vType: "info",
    },
  },
);
export type AlertProps = {
  className?: string;
  children: ReactNode;
} & VariantProps<typeof styles>;

const iconCss = "h-16 w-16 py-2 -mt-1 flex-shrink-0";
export function Alert({ className, vType, children }: AlertProps) {
  const [close, setClose] = useState(false);
  if (close) {
    return null;
  }
  return (
    <div className={cn(styles({ vType }), className)} role="alert">
      {vType === "warning" && <CircleAlertIcon className={iconCss} />}
      {vType === "info" && <InfoIcon className={iconCss} />}
      {vType === "success" && <CircleCheckIcon className={iconCss} />}
      {vType === "error" && <CircleXIcon className={iconCss} />}
      <div className="text-default h-full py-2">{children}</div>
      <IconButton
        className="text-default absolute right-4 top-4"
        type="button"
        onClick={() => setClose(true)}
      >
        <XIcon />
      </IconButton>
    </div>
  );
}
